import React, { useEffect, useRef } from "react";
import "./project-showcase.css";
import ImageCarousel from "../ui/image-carousel/image-carousel";

function ProjectShowcase({ id, projectName, images, description, links, initialLoad, reverse }) {
  const showcaseRef = useRef(null);

  useEffect(() => {
    if (initialLoad) {
      // The parent component handles the staggered animation, or we can do it here.
    }
  }, [initialLoad]);

  return (
    <section id={id} className={`project-feature-card ${reverse ? 'reverse-layout' : ''}`} ref={showcaseRef}>
      <div className="project-feature-image-container">
        {images && images.length > 0 && (
          <ImageCarousel
            id={`${id}-carousel`}
            images={images}
            alt={`${projectName} preview`}
            projectName={projectName}
            initialLoad={initialLoad}
          />
        )}
      </div>

      <div className="project-feature-content">
        <h3 className="project-feature-title">{projectName}</h3>
        <p className="project-feature-description">{description}</p>

        {links && links.length > 0 && (
          <div className="project-feature-links">
            {links.map((link, index) => (
              <button
                key={index}
                onClick={link.onClick}
                className="project-action-button"
              >
                {link.text ? link.text : <img src={link.icon} alt="link icon" />}
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default ProjectShowcase;
